import { inject, Injectable } from "@angular/core";
import { PlatformType } from "src/app/common/platform-type";
import { runAsyncOperation } from "src/app/support/async-operation";
import { PLATFORM_TOKEN } from "src/app/tokens/platform.token";

@Injectable()
export class AsyncService {
  private readonly PLATFORM = inject(PLATFORM_TOKEN);

  async run<T>(
    promiseFn: () => Promise<T>,
    options?: { container?: HTMLElement; appendToElement?: boolean }
  ): Promise<T> {
    let containerElement: HTMLElement;

    switch (true) {
      case this.PLATFORM === PlatformType.MOBILE: {
        containerElement = document.body;
        break;
      }
      default: {
        containerElement = options?.container || document.body;
        break;
      }
    }

    return await runAsyncOperation<T>(containerElement, promiseFn, options);
  }
}
